
const TableauPlanning = function(element, options) {
    this.element  = $(element);
    this.table    = this.element.find('table');
    this.body     = this.table.find('tbody');
    this.options  = options;

    this.vehicule = this.options.vehicule;
    this.date     = moment(this.options.date, "DD-MM-YYYY");
    this.now = $(this.options.now);
    this.btnPrev = $(this.options.button.prev);
    this.btnNext = $(this.options.button.next);

    this.btnPrev.on('click', $.proxy(this.onPrevClick, this));
    this.btnNext.on('click', $.proxy(this.onNextClick, this));

    this.element.on('change', 'select', $.proxy(this.onUtilisateurChange, this));
};

$.extend(TableauPlanning.prototype, {
    onPrevClick: function() {
        this.date.subtract(1, 'months');

        this.updatePlanning();
    },

    onNextClick: function() {
        this.date.add(1, 'months');

        this.updatePlanning();
    },

    updatePlanning: function() {
        this.now.text(this.date.format('MM/YYYY'));

        $.ajax({
            url: Routing.generate('vehicule_tableau', {
                vehicule: this.vehicule,
                date: this.date.format('DD-MM-YYYY')
            }),
            success: response => {
                this.element.html(response);
            }
        })
    },

    onUtilisateurChange: function(event) {
        var target = $(event.currentTarget);

        $.ajax({
            method: 'POST',
            url: Routing.generate('vehicule_planning_update', {
                vehicule: this.vehicule,
                date: target.attr('data-date').replace(/\//g, '-'),
                utilisateur: target.val(),
                token: this.element.attr('data-token')
            }),
            success: response => {
                Notifications.messages(response.messages);
            }
        })
    }
});

$.fn.tableauPlanning = function(options) {
    return $.each(this, function () {
        new TableauPlanning(this, options);
    })
};


// WEBPACK FOOTER //
// ./js/form/tableauPlanning.js